import React from 'react';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import cognitoConfig, { configValidation } from './utils/cognitoConfig';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import { LoggerProvider, loggerStatic as logger } from './utils/logger';
import ReactGA from 'react-ga4';

// Initialize Google Analytics
ReactGA.initialize('G-CTM5672S7L');

// Log the Cognito configuration on app startup
logger.info('App starting with Cognito configuration', {
  hasUserPoolId: !!cognitoConfig.UserPoolId,
  hasClientId: !!cognitoConfig.ClientId
});

// Test the Cognito configuration
try {
  const userPool = new CognitoUserPool({
    UserPoolId: cognitoConfig.UserPoolId,
    ClientId: cognitoConfig.ClientId,
  });
  logger.info('CognitoUserPool created successfully');
  
  if (!configValidation.isValid) {
    logger.warn('Cognito configuration is incomplete. Authentication features will be disabled.');
    logger.warn('Run the collect-stack-outputs.sh script to update environment files.');
  }
} catch (error) {
  logger.error('Error creating CognitoUserPool', error);
}

// Add this to ensure links always scroll to top
window.scrollTo(0, 0);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LoggerProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </LoggerProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(({ name, value }) => {
  ReactGA.event({
    category: 'Web Vitals',
    action: name,
    value: Math.round(value),
    nonInteraction: true,
  });
});
